const versions = {
  global: Symbol.for('global'),
  west: Symbol.for('west'),
  alpha: Symbol.for('alpha'),
};

export { versions };
